(function () {
    'use strict';

    angular
        .module('salesflare')
        .config(function ($mdDialogProvider) {

            $mdDialogProvider.addPreset('exportFieldsDialog', {
                options: function () {

                    return {
                        controllerAs: 'vm',
                        multiple: true,
                        clickOutsideToClose: true,
                        escapeToClose: true,
                        bindToController: true,
                        templateUrl: 'app-ajs/components/exportfieldsdialog/exportfieldsdialog.html',
                        controller: 'ExportFieldsDialogController',
                        onShowing: function (scope, element) {

                            element.children('md-dialog').addClass('export-fields-dialog');
                        }
                    };
                }
            });
        });
})();
